<template>
  <card-list
    :listItems = 'trainList'
    :itemComponent = 'trainCard'
    @list-item-clicked = 'onTrainClicked'
  >
    <div id="container">
      <div v-if="noTrain" style="text-align:center;margin-top:200px;font-size:28px;">敬请期待！</div>
      <digTrainContentmodal  :game="game" @close="showModal=false" v-if="showModal"></digTrainContentmodal>
    </div>
  </card-list>
</template>
<script>
import Vue from 'vue'
import digTrainContentmodal from './digTrainContentmodal.vue'
import level from '../../common/levels.vue'
import CardList from '../../../foundation/ui/controls/card-list';
import TrainListItem from '../../bz/train-card';

export default ({
  data() {
    return {
      trainCard: TrainListItem,
      store: require('../../../app/store.js'),
      showModal: false,
      showEvalModal:false,
      search: {
        keyword: ''
      },
      showInput:true,
      game: "",
      startType:"",
      flag:0,
      pages:1,
      caseIdDoc:"",
      scaleId: '',//量表id
      scaleAlias:"",
    }
  },
  props: {
    trainCategories: {
    },
    trainList: {
      default: ()=>([]),
    },
    noTrain:{},
  },
  components: {
    digTrainContentmodal,
    level,
    'card-list': CardList,
  },
  mounted(){
    
  },
  methods:{
    onTrainClicked: function(ev)
    {
      this.showDetail(ev.itemData, '');
    },
    showDetail:function(item,content){
      this.showInput = true;
      this.search.keyword = '';
      this.showModal=true;
      this.game = item;
    },
  }
})
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
  @import "../../../assets/css/app.styl";
  @import "../../../assets/css/variable.styl";
  .evalItem
    float left
    margin-top 0
    margin-left 30px
  .boardName
    text-align left
  .board img
    width 200px
</style>



// WEBPACK FOOTER //
// digTrainContent.vue?4a1fd209